(function() {
    const tsunamiVariants = ['41865540632641']; // Tsunami Blue (add more IDs here if there are other Tsunami color variants)
    const freeGiftVariantId = '44255654346817'; // 2 FREE Bonus Gifts - Paddle Cover + Carbon Paddle Cleaner

    const originalFetch = window.fetch;
    let debounceTimer = null;
    let isApplyingSync = false;

    async function syncGiftQuantity() {
        if (isApplyingSync) return false;

        const cartResp = await originalFetch('/cart.js');
        const cart = await cartResp.json();

        const tsunamiTotalQty = cart.items
            .filter(i => tsunamiVariants.includes(String(i.variant_id)))
            .reduce((sum, i) => sum + i.quantity, 0);

        const giftItem = cart.items.find(i => String(i.variant_id) === freeGiftVariantId);
        const currentGiftQty = giftItem ? giftItem.quantity : 0;

        if (tsunamiTotalQty === currentGiftQty) return false;

        isApplyingSync = true;
        try {
            if (!giftItem && tsunamiTotalQty > 0) {
                await originalFetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: freeGiftVariantId, quantity: tsunamiTotalQty }] })
                });
            } else if (giftItem) {
                await originalFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: freeGiftVariantId, quantity: tsunamiTotalQty })
                });
            }
        } finally {
            isApplyingSync = false;
        }
        return true;
    }

    function scheduleSync() {
        if (isApplyingSync) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
            syncGiftQuantity().then(function(changed) {
                if (changed && window.location.pathname === '/cart') {
                    window.location.reload();
                }
            }).catch(function(err) {
                console.error('[GiftScript-Tsunami] Sync error:', err);
            });
        }, 100);
    }

    // --- fetch() intercept ---
    window.fetch = async function(...args) {
        const url = args[0];
        const options = args[1] || {};
        const method = options.method ? options.method.toUpperCase() : '';

        const isCartAdd = typeof url === 'string' && url.includes('/cart/add.js') && method === 'POST';
        const isCartChange = typeof url === 'string' &&
            (url.includes('/cart/change.js') || url.includes('/cart/update.js') || url.includes('/cart/remove.js')) &&
            method === 'POST';

        if (isCartAdd && !isApplyingSync) {
            let addedVariantIds = [];
            let touchesFreeGift = false;
            try {
                if (options.body instanceof FormData) {
                    const idVal = options.body.get('id');
                    if (idVal) addedVariantIds.push(String(idVal));
                    if (idVal && String(idVal) === freeGiftVariantId) touchesFreeGift = true;
                } else if (typeof options.body === 'string') {
                    const parsedBody = JSON.parse(options.body);
                    if (parsedBody.id) addedVariantIds.push(String(parsedBody.id));
                    if (parsedBody.id && String(parsedBody.id) === freeGiftVariantId) touchesFreeGift = true;
                    if (Array.isArray(parsedBody.items)) {
                        parsedBody.items.forEach(item => addedVariantIds.push(String(item.id)));
                        if (parsedBody.items.some(it => String(it.id) === freeGiftVariantId)) touchesFreeGift = true;
                    }
                }
            } catch (err) {}

            const isTsunamiAdd = addedVariantIds.some(id => tsunamiVariants.includes(id));
            const addResponse = await originalFetch(...args);

            if (isTsunamiAdd && !touchesFreeGift) {
                try {
                    await syncGiftQuantity();
                } catch (err) {
                    console.error('[GiftScript-Tsunami] Sync error:', err);
                }
                window.location.href = '/cart';
            }
            return addResponse;
        }

        if (isCartChange && !isApplyingSync) {
            const response = await originalFetch(...args);
            scheduleSync();
            return response;
        }

        return originalFetch(...args);
    };

    // --- XMLHttpRequest intercept ---
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
        this._tsunamiGiftScriptUrl = url;
        this._tsunamiGiftScriptMethod = method;
        return originalXHROpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
        const url = this._tsunamiGiftScriptUrl || '';
        const method = (this._tsunamiGiftScriptMethod || '').toUpperCase();
        const isRelevant = typeof url === 'string' && method === 'POST' &&
            (url.includes('/cart/add.js') || url.includes('/cart/change.js') || url.includes('/cart/update.js') || url.includes('/cart/remove.js'));

        if (isRelevant && !isApplyingSync) {
            this.addEventListener('load', function() {
                scheduleSync();
            });
        }
        return originalXHRSend.apply(this, arguments);
    };

    // --- Cart page load hote hi ek dafa check (fallback safety net) ---
    if (window.location.pathname === '/cart') {
        document.addEventListener('DOMContentLoaded', function() {
            scheduleSync();
        });
    }

    console.log('[GiftScript-Tsunami] Installed — add-redirect + remove/change debounced sync');
})();